<!-- Template -->

<template>
	<div>
		<div class="system-info">
			<div>
                <div v-if="system.trainingStatus || system.ticketsCount > 0 || workOrderTypes.length > 0">
                    <h5>System status</h5>
                    <p>{{system.trainingStatus}}</p>
                    <p v-show="system.ticketsCount > 0">{{system.ticketsCount}} open ticket<span v-show="system.ticketsCount > 1">s</span></p>

                    <div v-if="workOrderTypes.length > 0" class="wo-container info">
                        <span>Next:</span>
                        <div><p v-for="wot in workOrderTypes" :key="wot.id"> {{wot.type}}</p></div>
                    </div>
                    <p v-else>Next: Not started</p>
                </div>
			</div>

			<div v-if="system.contractStatus">
				<h5>Service Status <span class="icon-star" v-if="!isExpired"></span></h5>
                <p v-show="system.contractStatus.toLowerCase() != 'warranty'">{{system.contractStatus}}</p>
				<div v-if="!isExpired">
					<p>Ends on {{system.contactEnd | date}}</p>
					<p class="red">({{system.contactEnd | time-left}})</p>
				</div>
				<div v-else>
					<p class="red">Expired</p>
				</div>
			</div>

			<div>
				<h5>Need help?</h5>
				<RaiseNewTicketButton :system="system" :showBack="false"/>
				<p><a href="https://www.visionrt.com/education/" target="_blank">Review our Knowledge Base</a></p>
			</div>
		</div>
        
	</div>
</template>

<!-- Script -->

<script>   
    import moment from 'moment';
    import RaiseNewTicketButton from '@/components/RaiseNewTicketButton';
    export default {
        name: 'SystemInfo',

		props: ['system'],
		
		components: {
            RaiseNewTicketButton
        },

        data(){
            return{
				isExpired:true,
                workOrderTypes:[]
            }
        },

        created(){
            if(this.system.workOrders.length > 0){
                var workOrders = this.system.workOrders.slice();

                workOrders.sort(function(a,b){
                    return new Date(a.visitDate) - new Date(b.visitDate);
                });

                var nextWorkOrder = null;
                for(var i = 0; i < workOrders.length; i++){
                    if(moment(workOrders[i].visitDate).isAfter(moment())){
                        nextWorkOrder = workOrders[i];
                        break;
                    }
                }

                if(nextWorkOrder != null){
                    for(var j = 0; j < workOrders.length; j++){
                        if(moment(workOrders[j].visitDate).format('YYYY-MM-DD') == moment(nextWorkOrder.visitDate).format('YYYY-MM-DD')){
                            if(workOrders[j].type != null){
                                this.workOrderTypes.push({
                                    id: workOrders[j].id,
                                    type: workOrders[j].type
                                });
                            }
                        }
                    }
                }
            }

            if(this.system.contractStatus){
                var date = moment(this.system.contactEnd).format('x');
                var now = moment.now();
                this.isExpired = ((parseInt(date) - parseInt(now))) <= 0;
            }
		}
    }
</script>

